import { OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import TaskBoardBase from '@/data/models/domain/tasks/TaskBoardBase'

@OrmModel(modelNames.TASK_BOARD_ARCHIVED)
export default class TaskBoardArchived extends TaskBoardBase {
  @StringField()
  public override archivedAt: string
}
